module.exports = __webpack_public_path__ + "media/images/universe_landing_pages/hero_banner/component/cleaning-mobile-a838a56ece591a0898a12f7aefc678c2.jpg";